const MERMAID_FILE_RE = /\.(?:mmd|mermaid)$/i;
const MERMAID_FENCE_RE =
  /^\s*\x60\x60\x60mermaid[^\S\r\n]*\r?\n([\s\S]*?)\r?\n\x60\x60\x60\s*$/i;

export function parseMermaidFence(text: string): string | null {
  const match = MERMAID_FENCE_RE.exec(text);
  const source = match?.[1]?.trim();
  return source ? source : null;
}

export function isMermaidFile(file: Pick<File, 'name'>): boolean {
  return MERMAID_FILE_RE.test(file.name);
}
